import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Box
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Client } from '../../apis/tenantApi/tenantApi';

interface Props {
  tenant: Client;
  onOpenReports: () => void; 
}

const ReportActionsMenu: React.FC<Props> = ({ tenant, onOpenReports }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewReports = () => {
    handleClose();
    onOpenReports(); 
  };

  return (
    <Box>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleViewReports}>Manage</MenuItem>
      </Menu>
    </Box>
  );
};

export default ReportActionsMenu;
